import { render, staticRenderFns } from "./DeleteActivityForm.vue?vue&type=template&id=107cf11a&scoped=true&lang=pug&"
import script from "./DeleteActivityForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./DeleteActivityForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DeleteActivityForm.vue?vue&type=style&index=0&id=107cf11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107cf11a",
  null
  
)

export default component.exports